import { Instance, SnapshotOut, types } from "mobx-state-tree"
import {Timestamp} from "firebase/firestore";
import {hasValue} from "../../utils/empty-check";

/**
 * Rick and Morty character model.
 */
export const BusinessModel = types.model("Business").props({
  id: types.maybe(types.string),
  name: types.string,
  owner: types.string,
  status: types.string,
  address1: types.string,
  address2: types.string,
  city: types.string,
  state: types.string,
  country: types.string,
  zip: types.string,
  phoneNumber: types.string,
  email: types.string,
  createdAt: types.maybe(types.string),
  updatedAt: types.maybe(types.string)
})

type BusinessType = Instance<typeof BusinessModel>
export interface Business extends BusinessType {}
type BusinessSnapshotType = SnapshotOut<typeof BusinessModel>
export interface BusinessSnapshot extends BusinessSnapshotType {}

export const businessFromJson = (docData) => {
  const updatedAtTimeStamp: Timestamp | string | undefined = docData.updatedAt;
  const createdAtTimeStamp: Timestamp | string | undefined = docData.createdAt;

  console.log("businessFromJson", docData)

  return {
    id: docData.id,
    name: docData.name,
    owner: docData.owner,
    status: docData.status ? docData.status : "Submitted",
    address1: docData.address1,
    address2: docData.address2,
    city: docData.city,
    state: docData.state,
    country: docData.country,
    zip: docData.zip,
    phoneNumber: docData.phoneNumber,
    email: docData.email,
    createdAt: createdAtTimeStamp instanceof Timestamp ? createdAtTimeStamp.toDate().toDateString() : createdAtTimeStamp,
    updatedAt: updatedAtTimeStamp instanceof Timestamp ? updatedAtTimeStamp.toDate().toDateString() : updatedAtTimeStamp
  }
}
